import GET_SUPPLIERS from '@/graphql/Suppliers.gql'
import { ref } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'

export function useSuppliers() {
  const { result, loading, error } = useQuery(
    GET_SUPPLIERS,
    null,
    { fetchPolicy: 'cache-first' }
  )
  const suppliers = useResult(result, [], data => data.suppliers)
  return { suppliers, loading, error}
}
